import Grid from '@blocks/Grid';
import Slider from '@blocks/Slider';
import React from 'react';

export default function SalonParticipationSlider({ participation }: Props) {
    return (
        <Slider src={participation.photo.url}>
            <Grid gap="15px" columns="2">
                <Grid gap="5px">
                    <h4>{participation.photo.title}</h4>
                    <small>Author: {participation.photo.user.first_name} {participation.photo.user.last_name}</small>
                    <small>Section: {participation.section.name}</small>
                </Grid>
                {Boolean(participation.votes.length) && 
                    <Grid gap="7px">
                        <h5>Votes</h5>
                        <Grid gap="5px">
                            {participation.votes.map(vote => <small>{vote.user.first_name} {vote.user.last_name}: {vote.score}</small>)}
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Slider>
    )
}

interface Props {
    participation: Admin.Resources.Participation
}

